<template>
  <div>
    <Header />
      <div id="modal-player" v-if="playVideo" @click="stopWatch()"  tabindex="-1" @keydown.esc="stopWatch">
        <iframe 
          width="640"
          height="360"
          :src="videoSrc"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen>
        </iframe>
      </div>
      <div>
      <div class="ajuda-page">
        <div id="ajuda">
          <div class="categoria-selector-column">
            <b-card>
              <b-card-header @click="expandedVideo = !expandedVideo">
                <h1>Vídeos</h1>
                  </b-card-header>
                  <transition name="slide-fade">
                  <b-card-text v-show="expandedVideo">
                    <b-button
                              v-for="categoria in videoCategorias"
                              :key="categoria"
                              @click="setVideoFilter(categoria)"
                              :variant="VideoCategoria === categoria ? 'primary' : 'outline-primary'"
                              class="card-categoria-selector">
                              {{ categoria }}
                            </b-button>
                    </b-card-text>
                  </transition>
                  </b-card>
                  <!-- <b-card>
                <b-card-header @click="expandedPDF = !expandedPDF">
                    <h1>PDFs</h1>
                    </b-card-header>
                  <transition name="slide-fade">
                    <b-card-text v-show="expandedPDF">
                      <b-button href="/" class="card-categoria-selector ">Cobrança</b-button>
                      <b-button href="/" class="card-categoria-selector ">Dívidas</b-button>
                      <b-button href="/" class="card-categoria-selector ">Inadimplência</b-button>
                      <b-button href="/" class="card-categoria-selector ">Protesto</b-button>
                      <b-button href="/" class="card-categoria-selector ">Protesto de títulos</b-button>
                      </b-card-text>
                  </transition>
                  </b-card> -->
                  </div>
                <div class="ajuda-content">
                <b-link v-for="ajuda in filteredAjudas" v-bind:key="ajuda.id_video" @click="watch(ajuda.href)" class="ajuda-card" >
                  <div class="ajuda-element-img-container">
                    <img :src="getAjudaThumb(ajuda.thumbnail)" :alt="ajuda.descricao"/>
                  </div>
                    <h3>{{ajuda.titulo}}</h3>
                  </b-link>
                    <div v-if="filteredAjudas.length === 0" class="no-results">
                        <p>Nenhum vídeo encontrado para a categoria selecionada.</p>
                    </div>
                </div>
              </div>
          </div>
        </div>
      <footersite class="d-none d-xl-block" />
      <footersitemobile class="d-block d-xl-none"/>
  </div>
</template>

<script>
import Header from '../components/Header';
import footersite from '../components/footersite';
import footersitemobile from '../components/footersite/index_mobile';

export default {
  components: {
    Header,
    footersite,
    footersitemobile
  },
  data() {
    return {
      mobile: window.innerWidth < 1200,
      expandedVideo: false,
      expandedPDF: false,
      playVideo: false,
      videoSrc: '',
      VideoCategoria: 'Todos', 
      videoCategorias: [
        'Todos', 
        'Certidão',
        'Protesto',
        'Cancelamento', 
        'Anuência', 
        'Retirada'
      ],

      ajudasData:[
        {
            id_video : 1,
            thumbnail:'17.1.jpg',
            descricao:'tutorial 1',
            titulo: 'Passo a passo de como solicitar a retirada de um título (desistência de protesto)',
            href:'https://www.youtube.com/watch?v=nQ7J0asAmNU',
            tags: ['Retirada']
        },
        {
            id_video : 2,
            thumbnail:'anuencia_ajuda.jpg',
            descricao:'tutorial 2',
            titulo: 'Passo a passo para emitir sua Anuência Eletrônica',
            href:'https://www.youtube.com/watch?v=Czet9wGvaFM',
            tags: ['Anuência']
        },
        { 
            id_video : 3,
            thumbnail:'cancelamento_ajuda.jpg',
            descricao:'tutorial 3',
            titulo: 'Passo a passo para Cancelar seu Protesto',
            href:'https://www.youtube.com/watch?v=N6Dc-Ro5id8',
            tags: ['Cancelamento']
        },
        {
            id_video : 4,
            thumbnail:'certidao_ajuda.jpg',
            descricao:'tutorial 4',
            titulo: 'Passo a passo de como solicitar uma Certidão de Protesto',
            href:'https://www.youtube.com/watch?v=UJRs-HzTM1E',
            tags: ['Certidão']
        },
          {
            id_video : 4,
            thumbnail:'ajuda_protesto.jpg',
            descricao:'tutorial 5',
            titulo: 'Passo a passo de como protestar uma dívida',
            href:'https://www.youtube.com/watch?v=7pafRfOmKMQ',
            tags: ['Protesto']
        },
      ],
    };
  },

  computed: {
    filteredAjudas() {
      if (this.VideoCategoria === 'Todos') {
        return this.ajudasData;
      }
      return this.ajudasData.filter(ajuda => 
        ajuda.tags && ajuda.tags.includes(this.VideoCategoria)
      );
    }
  },
    methods: {
    setVideoFilter(categoria) {
      this.VideoCategoria = categoria;
    },
    getAjudaThumb(imageSrc) {
    try {
        if (imageSrc.includes('png')) {
          var images = require.context('../assets/imgs/', false, /\.png$/);
          return images('./' + imageSrc);
        } else {
           images = require.context('../assets/imgs/', false, /\.jpg$/);
          return images('./' + imageSrc);
        }
      } catch (e) {
        console.error("Imagem não encontrada:", imageSrc);
        return ''; 
      }
    },
    watch(videoLink){

      let videoId = '';
      try {
        const url = new URL(videoLink);
        videoId = url.searchParams.get('v');
      } catch (e) {
        console.warn("Formato de URL de vídeo não padrão. Tentando extração manual.");
        const parts = videoLink.split('v=');
        if (parts.length > 1) {
          videoId = parts[1].substring(0, 11);
        }
      }

      if (videoId) {
        this.videoSrc = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
        this.playVideo = true;
        this.$nextTick(() => {
          var modal = document.getElementById("modal-player");
          if(modal) modal.focus();
        });
      } else {
        console.error("Não foi possível extrair o ID do vídeo do link:", videoLink);
      }
      },
      stopWatch(){
        this.playVideo = false;
      this.videoSrc = '';
      }
    },

  mounted() {
    if(!this.mobile){
      this.expandedVideo = true;
      this.expandedPDF = true;
    }
  },
}
</script>

<style scoped>

.card-categoria-selector {
  margin: 4px;
}

.no-results {
    width: 100%;
    text-align: center;
    color: #888;
    margin-top: 2rem;
}
</style>

<style scoped>

.ajuda-page{width: 100vw;height: 100vh;display: flex;justify-content: center;overflow: hidden;}
    #ajuda{margin: 0 auto;margin: 120px 0 37px 0;width: 100%;display: flex;overflow: overlay;padding: 0 72px;}
      #ajuda .ajuda-content{display: flex;flex-wrap: wrap;padding-top: 113px;padding-bottom: 101px;}
        #ajuda .ajuda-content .ajuda-card {display: flex;flex-flow: column;width: 320px;flex:1 1 320px;text-decoration: none;margin-bottom: 44px;}
          #ajuda .ajuda-content .ajuda-card .ajuda-element-img-container {width: 320px;height:186px;display: flex;justify-content: center;align-items: center;overflow: hidden;margin-bottom: 18px;}
            #ajuda .ajuda-content .ajuda-card .ajuda-element-img-container img {height: 100%;width: 320px;left:12px;position:relative;object-fit: cover;filter: brightness(0.5);}
            #ajuda .ajuda-content .ajuda-card .ajuda-element-img-container::after {content: '';width: 23.5px;height: 29.5px;border-left: 23.5px solid white;border-top: 14.75px solid transparent;border-bottom: 14.75px solid transparent;position: relative;left: -50%;z-index: 1;}
          #ajuda .ajuda-content .ajuda-card h3{font: normal normal bold 20px/27px 'Kanit', sans-serif; letter-spacing: 0px;color: #707070;margin:0;height: 135px;width: inherit;}
#modal-player{position: fixed;width: 100vw;height: 100vh;z-index: 1000;background-color: #000000bf;display: flex;align-items: center;justify-content: center;}

.categoria-selector-column{padding-top: 56px;display: flex;flex-flow: column;padding-right: calc(((100vw - 964px)/2) - (296px + 72px));}
  .categoria-selector-column .card{display: flex;flex-flow: column;width:296px;border: none;padding: 0;margin-bottom: 46px;}
  .categoria-selector-column .card h1{text-align: left;font: normal normal bold 20px/27px 'Kanit', sans-serif; letter-spacing: 0px;color: #597EB5;margin: 0;}
    .categoria-selector-column .card .card-body{display: flex;flex-flow: column;width:296px;border: none;padding: 0;}
      .categoria-selector-column .card .card-body .card-header{padding: 0;background-color: unset;padding-bottom: 24px;border-bottom: 3px solid #597EB5;margin-bottom: 24px;}
      .categoria-selector-column .card .card-body .card-text{display: flex;flex-flow: column;padding: 0;}
        .categoria-selector-column .card .card-body .card-text a.card-categoria-selector{width: 100%;height: 40px;background: #F1F1F1 0% 0% no-repeat padding-box;border:none;text-align: center;font: normal normal bold 15px/20px 'Kanit', sans-serif; letter-spacing: 0px;color: #597EB5;padding: 10px 0;}
        .categoria-selector-column .card .card-body .card-text a.card-categoria-selector:not(:last-child){margin-bottom: 15px;}

  @media (max-width: 1700px) and (min-width: 1601px) {
    .categoria-selector-column {padding-right: calc(((100vw - 964px)/2 - 72px - 15.26vw));}
  }
  @media (max-width: 1700px) and (min-width: 1500px) {
    .categoria-selector-column .card, .categoria-selector-column .card .card-body{width: 15.26vw;}
  }
  @media (max-width: 1600px) and (min-width: 1400px) {
    #ajuda{padding: 0 20px;}
      .categoria-selector-column {padding-right: calc(((100vw - 964px)/2 - 20px - 15.26vw));}
  }
  @media (max-width: 1499px) and (min-width: 1200px) {
      .categoria-selector-column {padding-right: 59px;}
      #ajuda .ajuda-content .ajuda-card h3{font-size: 1rem; line-height: 1.35rem;}
  }
  @media (max-width: 1399px) and (min-width: 1200px){
    #ajuda{padding: 0 10px;}
  }
  @media (max-width: 1199px) {
    .ajuda-page{height: fit-content;}
    #ajuda{flex-flow: column;margin-top: 68px;padding: 0 20px;padding-top: 46px;width: 100%;margin-bottom: 206px;scrollbar-width:none;}
    #ajuda::-webkit-scrollbar{display: none;}
    #ajuda .ajuda-content{padding: 0 8px;}
    .categoria-selector-column{padding: 0;}
    .categoria-selector-column .card{width: 100%;}
    .categoria-selector-column .card .card-body .card-header{cursor: pointer;padding-bottom: 10px;display: flex;align-items: center;}
    .categoria-selector-column .card .card-header::after{content: '';width: 11px;height: 11px;border-left: 3px solid #597EB5;border-bottom: 3px solid #597EB5;transform: rotate(-45deg);position: absolute;right: 2px;}
    .categoria-selector-column .card .card-body{width: 100%;}

    #ajuda .ajuda-content .ajuda-card{width: calc(100vw - 40px - 16px);max-width: none;flex: unset;margin-bottom: 39px;}
    #ajuda .ajuda-content .ajuda-card .ajuda-element-img-container{width: calc(100vw - 40px - 16px);height:calc((100vw - 40px - 16px) / 1.72);}
    #ajuda .ajuda-content .ajuda-card .ajuda-element-img-container img{width: inherit;height: inherit;}
    #ajuda .ajuda-content .ajuda-card h3{height: fit-content;padding-right: 30px;}

    
    .slide-fade-enter-active {
      transition: all .3s ease;
    }
    .slide-fade-leave-active {
      transition: all .3s ease;
    }
    .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }
  }
</style>